import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/solid';
import {
    SiDiscord,
    SiGithub,
    SiInstagram,
    SiLinkedin,
    SiMastodon,
    SiMatrix,
    SiReddit,
    SiX,
} from '@icons-pack/react-simple-icons';

export interface ISocialPresence {
    url: string;
    name: string;
    icon: JSX.Element;
}

export const twitterURL = 'https://twitter.com/enteio';
export const discordDirectURL = 'https://discord.gg/z2YVKkycX3';
export const discordRedirectURL = 'https://ente.io/discord';
export const redditURL = 'https://reddit.com/r/enteio';
export const instaURL = 'https://instagram.com/ente.app';
export const mastodonURL = 'https://mstdn.social/@ente';
export const matrixDirectURL = 'https://matrix.to/#/#ente:matrix.org';
export const matrixRedirectURL = 'https://ente.io/matrix';
export const githubURL = 'https://github.com/ente-io';
export const linkedinURL = 'https://www.linkedin.com/company/ente-io'
export const figmaURL = 'https://www.figma.com/file/SYtMyLBs5SAOkTbfMMzhqt/ente-Visual-Design'

/**
  List of social presences surfaced in the footer.
 
  ### [Note: Icons]
 
  Brand icons from:
  - https://simpleicons.org/
 
  Brand icons library docs:
  - https://github.com/icons-pack/react-simple-icons
 
  Non-brand icons from:
  - https://heroicons.com

  Notes:
  - Simpleicons default to 24x24px
  - We need to provide an explicit width (or height) to heroicons
 
 */
export const socialMedia: ISocialPresence[] = [
    {
        url: twitterURL,
        name: 'X (formerly Twitter)',
        icon: <SiX />,
    },
    {
        url: discordDirectURL,
        name: 'Discord',
        icon: <SiDiscord />,
    },
    {
        url: redditURL,
        name: 'Reddit',
        icon: <SiReddit />,
    },
    {
        url: instaURL,
        name: 'Instagram',
        icon: <SiInstagram />,
    },
    {
        url: 'mailto:contact@ente.io',
        name: 'Email',
        icon: <EnvelopeIcon width={24} />,
    },
    {
        url: mastodonURL,
        name: 'Mastodon',
        icon: <SiMastodon />,
    },
    {
        url: matrixDirectURL,
        name: 'Matrix',
        icon: <SiMatrix />,
    },
    {
        url: 'https://www.linkedin.com/company/ente-io',
        name: 'LinkedIn',
        icon: <SiLinkedin />,
    },
    {
        url: githubURL,
        name: 'GitHub',
        icon: <SiGithub />,
    },
];
